module.exports = __webpack_public_path__ + "static/media/Artboard9.5bc4fcf4.jpg";